module.exports = __webpack_public_path__ + "static/media/Developmenticon05@2x.3440531e.png";